import React, {Component} from "react"
import "./Reply.sass"

class Reply extends Component {
  constructor() {
    super()
    this.state = {
      currentPage: 0,
      maxPages: 1,
      input1: JSON.parse(localStorage.getItem('InputParams1')),
      input2: JSON.parse(localStorage.getItem('InputParams2'))
    }
  }

  render() {

    if (!this.state.input1 || !this.state.input2) {
      return (
        <main className='reply'>

          <h1 className='reply__mainTitle'>Отчет БД</h1>

          <div className="reply-content">

            <h2 className="reply__error">Сохраните исходные данные заготовки и детали</h2>

          </div>

        </main>
      )
    }

    const diskParams = this.state.input1.diskParams.split(' ')

    return (
      <main className='reply'>

        <h1 className='reply__mainTitle'>Отчет БД</h1>

        <div className="reply-content">

          <h2 className="reply__title">Исходные данные</h2>

          <div className="reply-descr">

            <div className="reply-info">
              <span className="reply-info__key">Вид шлифования</span>
              <span className="reply-info__value">{this.state.input2.typePol}</span>
            </div>

            <div className="reply-info">
              <span className="reply-info__key">Обрабатываемый материал</span>
              <span className="reply-info__value">{this.state.input1.material.split(' ')[0].split('|').join(' ')}</span>
            </div>

            <div className="reply-info">
              <span className="reply-info__key">Ширина заготовки</span>
              <span className="reply-info__value">{this.state.input1.width}</span>
            </div>

            <div className="reply-info">
              <span className="reply-info__key">Длина заготовки</span>
              <span className="reply-info__value">{this.state.input1.length}</span>
            </div>

            <div className="reply-info">
              <span className="reply-info__key">Ширина обрабатываемой поверхности</span>
              <span className="reply-info__value">{this.state.input2.width}</span>
            </div>

            <div className="reply-info">
              <span className="reply-info__key">Длина обрабатываемой поверхности</span>
              <span className="reply-info__value">{this.state.input2.length}</span>
            </div>

            <div className="reply-info">
              <span className="reply-info__key">Квалитет точности</span>
              <span className="reply-info__value">{this.state.input2.quality}</span>
            </div>

            <div className="reply-info">
              <span className="reply-info__key">Шероховатость поверхности мкм.</span>
              <span className="reply-info__value">{this.state.input2.roughness}</span>
            </div>

            <h2 className="reply__title">Маршрут обработки</h2>

            <div className="reply-wrapper">

              <span className="reply-wrapper__key">Переход 1:</span>
              <span className="reply-wrapper__value">1) Предварительное шлифование</span>
              <span className="reply-wrapper__key">Припуск:</span>
              <span className="reply-info__value">0,12</span>

            </div>

            <div className="reply-wrapper">

              <span className="reply-wrapper__key">Переход 2:</span>
              <span className="reply-wrapper__value">2) Окончательное шлифование</span>
              <span className="reply-wrapper__key">Припуск:</span>
              <span className="reply-info__value">0,08</span>

            </div>

            <h2 className="reply__title">Шлифовальный круг</h2>

            <div className="reply-info">
              <span className="reply-info__key">Диаметр круга мм.</span>
              <span className="reply-info__value">350</span>
            </div>

            <div className="reply-info">
              <span className="reply-info__key">Абразивный материал</span>
              <span className="reply-info__value">{diskParams[0]}</span>
            </div>

            <div className="reply-info">
              <span className="reply-info__key">Зернистость</span>
              <span className="reply-info__value">{diskParams[1]}</span>
            </div>

            <div className="reply-info">
              <span className="reply-info__key">Твердость</span>
              <span className="reply-info__value">{diskParams[2]}</span>
            </div>

            <div className="reply-info">
              <span className="reply-info__key">Структура и связка</span>
              <span className="reply-info__value">{diskParams[3]}</span>
            </div>

            <h2 className="reply__title">Режим шлифования</h2>

            <div className="reply-info">
              <span className="reply-info__key">Vg, м/мин</span>
              <span className="reply-info__value">30</span>
            </div>

            <div className="reply-info">
              <span className="reply-info__key">Snon, мм/дв.ход</span>
              <span className="reply-info__value">#####</span>
            </div>

            <div className="reply-info">
              <span className="reply-info__key">Sверт, мм</span>
              <span className="reply-info__value">0,015</span>
            </div>

            <div className="reply-info">
              <span className="reply-info__key">N, кВт</span>
              <span className="reply-info__value">3,27</span>
            </div>

            <div className="reply-info">
              <span className="reply-info__key">T, мин</span>
              <span className="reply-info__value">#####</span>
            </div>

          </div>

        </div>

      </main>
    )

  }

}

export default Reply